
function boost_checker_build(){

  document.querySelector('.boost-sd__toolbar-item.compare-product .toggle-label').innerHTML = compare_translate.compare;
  document.querySelectorAll('.compare-boost-integration.compare-checker').forEach(item=>{
    item.dataset.titleMax = compare_translate.max_amount;
  });

  //Boost AI conflict fix
  document.querySelector('.boost-sd__toolbar-item.compare-product label').addEventListener('click', (e)=>{e.stopPropagation()});
  
  document.getElementById('compare-element-switcher')?.addEventListener('change',function(e){
      this.checked ? compareBuilder.activate() : compareBuilder.deactivate();
  });

  if(location.href.includes('compare-builder')){
    document.getElementById('compare-element-switcher').checked = true;
  }


  product_compare_checkbox_action();




  //Observer logic
  let observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      product_compare_checkbox_action();
    }
  });
  // Start observing
  observer.observe(document.querySelector('.boost-sd__product-list'), {childList: true});





  function product_compare_checkbox_action(){

    
    document.querySelectorAll('.boost-sd__product-list .compare-product-checkbox:not(.compare-applied)').forEach(item=>{
      item.addEventListener('change', (e)=>{
        item.closest('label').classList.toggle('active');
        let handle = item.dataset.handle;
        if(item.checked){
          let image = item.closest('div').querySelector('.boost-sd__product-image-img:first-child').outerHTML;
          compareBuilder.add(handle, image);
        }
        else{
          compareBuilder.delete(handle);
        }
      });
      item.classList.add('compare-applied');
    });

    document.querySelectorAll('.compare-boost-integration.compare-checker').forEach(item=>{
      item.dataset.titleMax = compare_translate.max_amount;
    });

    compareBuilder.data.forEach(item=>{
      compareBuilder.product_checkbox_switcher(item[0], true);
    });
  }
  
  
}


  





document.addEventListener('boost-elements-ready', ()=>{

    if(!document.querySelector('.boost-sd__product-list')){
      setTimeout(function(){
        document.dispatchEvent(new CustomEvent('boost-elements-ready'));
      },150);
      return false;
    }

    
    boost_checker_build();
	compareBuilder.init();

	//Delete element by clicking on the "Delete" button in the product list
	compareBuilder.products_list_element.addEventListener('click', (e)=>{
		if(e.target.classList.contains('icon-close-thick')){
			let spot = e.target.closest('li');
			if(!spot.classList.contains('active')){
				return false;
			}

			compareBuilder.product_checkbox_switcher(spot.dataset.handle, false);
			compareBuilder.delete(spot.dataset.handle, spot);
		}
	})


	//Add smooth roll down / roll up animation
	compareBuilder.main_block_element.addEventListener('animationend', function(){
		this.style.display = document.body.classList.contains('compare-mode-active') ? "flex" : this.style.display = "none";
	});

	compareBuilder.compare_clear_element.addEventListener('click', ()=>{
		compareBuilder.clear();
	});

	//Preven Button Click if we don't have at least 2 element to compare
	compareBuilder.compare_button_element.addEventListener('click',(e)=>{
		if(compareBuilder.data.length < 2){
			e.preventDefault();
		}
	})

	window.addEventListener('resize', (e)=>{
		compareBuilder.max_product = window.matchMedia('(max-width: '+compareBuilder.mobile_resolution+'px)').matches ? 2 : 4;
	});

	compareBuilder.main_block_element.querySelector('.icon-close-thick').addEventListener('click',(e)=>{
		compareBuilder.deactivate();
		document.getElementById('compare-element-switcher').checked = false;
	})



    //Observer logic
    let observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        boost_checker_build();
      }
    });
    // Start observing
    observer.observe(document.querySelector('.boost-sd__filter-product-list'), {childList: true});
  

})


document.addEventListener('url-change', (e)=>{
	if(document.body.classList.contains('compare-mode-active')){
		compareBuilder.activate();
	}
})


document.addEventListener('collection-content-changed', (e)=>{
	compareBuilder.data.forEach(item=>{
		compareBuilder.product_checkbox_switcher(item[0], true);
	});

  
})



let compareBuilder = {
	data: JSON.parse(localStorage.getItem(collection_handle)) || [],
	mobile_resolution:600,
	init:function(){
		this.main_block_element = document.querySelector('.compare-builder');
		this.products_list_element = this.main_block_element.querySelector('.products');
		this.product_spots_element = this.products_list_element.querySelectorAll('li');
		this.compare_button_element = this.main_block_element.querySelector('.compare-link');
		this.compare_counter_element = this.main_block_element.querySelector('.controls .amount');
		this.compare_clear_element =this.main_block_element.querySelector('.controls .clear');

		this.max_product = window.matchMedia('(max-width: '+this.mobile_resolution+'px)').matches ? 2 : 4;
		//Build actual state of the Compare Builder, in case we needed to reopen the page

		if(localStorage.getItem(collection_handle)){
			this.data.forEach(item=>{
				this.add(item[0], item[1], true);
			});

			//If we reached max comare amount (2 or 4) - disabled Compare Checkboxes
			if(this.data.length >= this.max_product){

				document.querySelector('.boost-product-listing-column')?.classList.add('compare-reached-limit');

				document.querySelectorAll('.compare-checker:not(.active)').forEach(item=>{
					item.title = item.dataset.titleMax;
					item.querySelector('input').disabled = true;
				});
			}

		}

		if(location.href.includes('compare-builder')){
			//Show It
			document.getElementById('compare-element-switcher').checked = true;
			this.activate();
		}
	},

	activate:function(){
		document.body.classList.add('compare-mode-active');
		//Add Compare Builder Active Status to URL
		let current_url = location.href;
		if(current_url.includes('compare-builder')){
			return false;
		}
		current_url += (current_url.includes('?') ? '&' : '?') + 'compare-builder=true';
		history.pushState({}, '', current_url);
	},

	deactivate:function(){
		document.body.classList.remove('compare-mode-active');
		//Add Compare Builder Unactive Status to URL
        let current_url =  location.href.replace(/&?compare-builder=true/,'').replace(/&&/,'&').replace(/\?&/,'?').replace(/\?$/,'')
		history.pushState({}, '', current_url);
	},



	add:function(product_handle, image_html, just_show = false){
		//Can't add more than 4
		if(!just_show){
			if(this.data.length >= this.max_product){
				return false;
			}
			//Save updated data in temporal storage and LocalStorage
			this.data.push([product_handle, image_html])
		}
		
		/*
			If we reached max comare amount (2 or 4) - disabled Compare Checkboxes
			Don't run if we rebuild after page refresh
		*/
		if(this.data.length >= this.max_product && !just_show){
			document.querySelector('.boost-product-listing-column')?.classList.add('compare-reached-limit');
			document.querySelectorAll('.compare-checker:not(.active)').forEach(item=>{
				item.title = item.dataset.titleMax;
				item.querySelector('input').disabled = true;
			});
		}

		//Get unused spot and take it
		let spot = this.products_list_element.querySelector('li:not(.active)');
		spot.innerHTML+=image_html;
		spot.dataset.handle = product_handle;
		spot.classList.add('active');

		this.actions_after_change();
	},

	delete:function(product_handle, spot = false){

		document.querySelector('.boost-product-listing-column')?.classList.remove('compare-reached-limit');
		document.querySelectorAll('.compare-checker:not(.active)').forEach(item=>{
			item.title = '';
			item.querySelector('input').disabled = false;
		});

		this.data = this.data.filter(item=>{
			return item[0] != product_handle;
		});

		if(!spot){
			this.product_spots_element.forEach(item=>{
				if(item.dataset.handle == product_handle){
					spot = item;
				}
			});
		}

		spot.addEventListener('transitionend', (e)=>{
			if(e.propertyName != 'width'){
				return false;
			}
			spot.remove();
			let new_spot = compareBuilder.product_spots_element[compareBuilder.product_spots_element.length - 1].cloneNode(true);
			compareBuilder.products_list_element.appendChild(new_spot);
			compareBuilder.product_spots_element = compareBuilder.products_list_element.querySelectorAll('li');
		});
		spot.classList.add('deletion-process');


		this.actions_after_change();
	},


	product_checkbox_switcher:function(handle, status){
		let product_compare_switcher = document.querySelector('.compare-checker input[data-handle="'+handle+'"]');
		if(!product_compare_switcher){
			return false;
		}
		product_compare_switcher.checked = status;
		status ? product_compare_switcher.closest('label').classList.add('active') : product_compare_switcher.closest('label').classList.remove('active');
	},


	actions_after_change:function(){
		//Save updated data in Local Storage 
		localStorage.setItem(collection_handle, JSON.stringify(this.data));

		this.data.length > 0 ? this.compare_clear_element.classList.add('active') : this.compare_clear_element.classList.remove('active');

		//Change Compare Counter
		this.compare_counter_element.innerHTML = this.data.length;

		//Regenerate link
		if(this.data.length > 1){
			this.compare_button_element.classList.add('active');

			let compare_url = this.data.reduce((result,item)=>{
				return result+','+item[0];
			},`${Shopify.routes.root}pages/compare/${collection_handle}`);

			this.compare_button_element.href = compare_url;
			this.compare_button_element.title = '';
		}
		else{
			this.compare_button_element.title = this.compare_button_element.dataset.titleBlock;
			this.compare_button_element.classList.remove('active');
		}
	},


	clear:function(){
		this.data = [];
		localStorage.removeItem(collection_handle);

		//Remove All Images
		compareBuilder.product_spots_element.forEach(item=>{
			if(!item.classList.contains('active')){
				return false;
			}

			//Remove All Checked Checkboxes
			compareBuilder.product_checkbox_switcher(item.dataset.handle, false);

			item.classList.remove('active');
			item.dataset.handle = '';
			item.querySelector('img').addEventListener('transitionend',function(e){
				if(e.propertyName == 'opacity'){
					this.remove();
				}
			});
		});

		this.actions_after_change();
	}
}





